export const getTime = () =>
  new Date().toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  })

export const getMessageId = () =>
  `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`

export const normalizePersistedId = (value) => {
  if (value === null || value === undefined) return null

  if (typeof value === 'string') {
    const trimmed = value.trim()

    if (
      trimmed === '' ||
      trimmed.toLowerCase() === 'null' ||
      trimmed.toLowerCase() === 'undefined'
    ) {
      return null
    }
  }

  return value
}